import { TabPanel, TabView } from 'primereact'
import React, { useEffect, useState } from 'react'
// import { getInventarioProductosExistentes, getProductosActivos } from '../../../../utils/Productos/Productos_Service';
import { getInventarioProductosExistentes, getProductosActivos } from '../../../../API/Productos/ProductosRequests';
import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid';
import { setTitlePage } from '../../../../Base/Services/Config/ConfigService';


const InventarioMantenimiento = () => {

  const [Productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(false);

  const getInfo = async () => {
    setProductos([]);
    setLoading(true);
    const t = await getInventarioProductosExistentes();
    // console.log(t);
    setProductos(t);
    setLoading(false);
  }

  const columns = [
    {
      header: 'Codigo',
      field: 'CodigoProducto',
      className: 'small'
    },
    {
      header: 'Producto',
      field: 'NombreProducto',
      className: 'XXXXlarge',
      Sumary: 'count'
    },
    {
      header: 'Tipo',
      field: 'NombreTipo',
      className: 'small'
    },
    {
      header: 'Categoria',
      field: 'NombreCategoria',
      className: 'large'
    },
    //   {
    //     header: 'SubCategoria',
    //     field: 'SubCategoria',
    //     className: 'small'
    // },
    {
      header: 'Unidad',
      field: 'UnitName',
    },
    {
      header: 'Inventario',
      field: 'Inventario',
      Format: 'Decimal'
    },

  ]
  const table = {
    Columns: columns,
    Data: Productos,
    loading: loading
  }

  useEffect(() => {
    getInfo();
    setTitlePage('Productos')
  }, [])

  return (
    <div style={{ height: '80vh' }} className='p-3'>
      <AgGrid table={table} />
    </div>
  )
}

export default InventarioMantenimiento